                               
<div class="pdf-container">
    @if (hasError) {
        <app-info-card title="Fehler" text="Die Vorschau für dieses Dokument kann nicht erzeugt werden" icon="fas fa-exclamation-triangle"></app-info-card>
    } 
    @if (pdfViewerVisible && src != null && src != "") {
        <ngx-extended-pdf-viewer
            [class.hidden]="hasError"
            class="flex-item-fill"
            [src]="src"
            [language]="pdfLanguage"
            localeFolderPath="/assets/locale"
            [showPrintButton]="allowPrint"
            [ignoreKeys]="['CTRL+S', 'META+S']"
            [showOpenFileButton]=false
            [showSidebarButton]="developerPreset"
            [showFindButton]=true
            [showPagingButtons]=true
            [showZoomButtons]=true
            [showZoomDropdown]=true
            [showDownloadButton]=true
            [showSecondaryToolbarButton]="developerPreset"
            [showPresentationModeButton]="developerPreset"
            [showHandToolButton]="developerPreset"
            [showRotateButton]="developerPreset"
            [showScrollingButtons]="developerPreset"
            [showSpreadButton]="developerPreset"
            [showPropertiesButton]="developerPreset"
            [showTextEditor]="developerPreset"
            [showStampEditor]="developerPreset"
            [showCommentEditor]="developerPreset"
            [showDrawEditor]="developerPreset"
            [showHighlightEditor]="developerPreset"
            [showSignatureEditor]="developerPreset"
            [showToolbar]="!app.isMobile()"
            [showBorders]="!app.isMobile()"
            [zoom]="zoom"
            [page]="page"
            [logLevel]=0
            (pdfLoadingFailed)="onError($event)"
            (pdfLoaded)="onLoaded()"
            (pageRendered)="onRendered()"
            (zoomChange)="onRendered()">
        </ngx-extended-pdf-viewer>
    }
</div>
